<!-- <hr style="margin-top: 0px; margin-bottom: 0px;"> -->

<div class="col-md-12" *ngIf="awaitDevices && awaitSensorUUIDs && awaitAssociatedUserGroups; else loading">
    <p-confirmDialog key="cd1" #cd1>
        <ng-template #footer>
            <button type="button" class="btn btn-success" (click)="cd1.onAccept()">Yes</button>
            <button type="button" class="btn btn-basic" (click)="cd1.onReject()">No</button>
        </ng-template>
    </p-confirmDialog>
    <p-confirmDialog key="registration" #registration>
        <ng-template #footer>
            <button type="button" class="btn btn-success" (click)="registration.onAccept()">Continue</button>
            <button type="button" class="btn btn-basic" (click)="registration.onReject()">Cancel</button>
        </ng-template>
    </p-confirmDialog>

    <p-table #deviceManagerTable [columns]="DeviceCols" [value]="devicesDisplayed" sortField="name" [scrollable]="true" scrollHeight="65vh">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;" [ngClass]="{'text-center': col.header == 'IngestStats' || col.header == 'Trusted' }">
                    <div *ngIf="col.field == 'checked'" (click)="toggleCheckedDevicesDisplayed()" style="padding-left: 2px; font-size: 20px;">▣</div>
                    {{col.header}}
                    <!-- <p-sortIcon *ngIf="col.header == 'Device Owner' || col.header == 'Last Check-in'" [field]="col.field"></p-sortIcon> -->
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr style="height: 40px;">
                <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                    <div *ngIf="rowData.source != 'Internal'" >
                        <p-checkbox [(ngModel)]="rowData.checked" binary="true" id="{{rowData.serialNumber}}" name="{{rowData.serialNumber}}" [ngModelOptions]="{standalone: true}" (ngModelChange)="deviceCheckedChanged()" [disabled]="rowData.userFeatureAccess['EditDevice'] == false"></p-checkbox>
                    </div>
                </td>

                <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    {{rowData.name}}
                </td>

                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    {{rowData.description}}
                </td>

                <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    {{ rowData.registerDate | date : 'medium' }}
                </td>

                <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    {{getOwnerName(rowData)}}
                </td>

                <td class="text-center" [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    <span *ngIf="rowData.userFeatureAccess['EditDevice']" class="serial-cell css-tooltip" [attr.tooltip-data]="rowData.serialNumber">{{getHiddenSerialNumber(rowData.serialNumber)}}<i class="far fa-copy serial-copy-icon" title="Copy serial number" (click)="copySerialNumber(rowData.serialNumber, $event)"></i></span>
                    <span *ngIf="!rowData.userFeatureAccess['EditDevice']">{{getHiddenSerialNumber(rowData.serialNumber)}}</span>
                </td>

                <td class="text-center" [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    <div style="display: flex;">
                        <div style="width: 90%;">
                            <div *ngIf="rowData.isDisabled" style="height: 17px;">
                                <label style="color: black; font-size: 13px;">not monitored</label>
                            </div>
                            <div *ngIf="!rowData.isDisabled" [ngStyle]="{'background-color': rowData.aliveColor}" class="kig-on-color-bg" style="height: 17px; font-size: 13px; padding-top: 2px;">
                                {{ getDeviceAliveStatus(rowData.aliveTimeStamp) }}
                            </div>
                            <div *ngIf="rowData.serialNumber != undefined && rowData.serialNumber != '' && !rowData.isDisabled" style="margin-top: 3px;" >
                                <table style="width: 100%;">
                                    <tr style="font-size: 6px; line-height: 6px">
                                        <td *ngFor="let connection of rowData.connectivity; let i = index" [ngStyle]="{'background-color': connection.color}" style="border-color: white; border-width: 1px;">
                                            <div class="css-tooltip" [attr.tooltip-data]="getConnectivityToolTipInfo(rowData, i)" style="font-size: 13px;">&nbsp;</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div *ngIf="rowData.serialNumber != undefined && rowData.serialNumber != ''"
                            class="fas fa-chart-line"
                            (click)="showSensorDataPreviewForDevice(rowData)"
                            style="color: #1c4966; cursor: pointer; font-size: 16px; margin-left: 10px; width: 10%; margin-top: 4px;">
                        </div>
                    </div>
                </td>

                <td class="text-center" [ngStyle]="{'width': columns[7].width}" style="cursor: pointer; flex: none; border-width: 0px; vertical-align: middle;">
                    <div *ngIf="rowData.serialNumber != null && rowData.serialNumber != ''" (click)="getDeviceVersionInfo(rowData)">
                        <div *ngIf="rowData.version === 'checking'" style="font-size: 14px;" class="fa fa-spinner fa-spin fa-1x fa-fw"></div>
                        <div *ngIf="rowData.version != 'checking'" class="css-tooltip4" [attr.tooltip-data]="rowData.versionTooltip">{{ rowData.version }}</div>
                    </div> 
                </td>

                <td class="text-center" [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    <div *ngIf="!rowData.userFeatureAccess['EditDevice']" class="css-tooltip" [attr.tooltip-data]="getDeviceTrustMessageForTooltip(device)">
                        <span *ngIf="rowData.trustInfo.isRegistered" class="fa-regular fa-registered" style="color: #64a70b;"></span>
                        <span *ngIf="!rowData.trustInfo.isRegistered" class="fa-regular fa-registered" style="color: lightgray"></span>
                        &nbsp;
                        <span *ngIf="rowData.trustInfo.isTrusted" class="fa-regular fa-thumbs-up" style="color: #64a70b;"></span>
                        <span *ngIf="!rowData.trustInfo.isTrusted" class="fa-regular fa-thumbs-down" style="color: #c8102e;"></span>
                        &nbsp;
                        <span *ngIf="rowData.trustInfo.expireDays < 90" style="color: darkgoldenrod;" >
                            <i class="fa-solid fa-circle-exclamation"></i>
                        </span>
                    </div> 

                    <div *ngIf="rowData.userFeatureAccess['EditDevice']" class="css-tooltip" [attr.tooltip-data]="getDeviceTrustMessageForTooltip(rowData)">
                        <span *ngIf="rowData.trustInfo.isRegistered" class="fa-regular fa-registered" style="cursor: pointer; color: #64a70b;" (click)="removeDeviceRegistration(rowData)"></span>
                        <span *ngIf="!rowData.trustInfo.isRegistered" class="fa-regular fa-registered" style="cursor: pointer; color: lightgray" (click)="registerDevice(rowData, registrationResultsTemplate)"></span>
                        &nbsp;
                        <span *ngIf="rowData.trustInfo.isTrusted" class="fa-regular fa-thumbs-up" style="cursor: pointer; color: #64a70b;" (click)="untrustDevice(rowData)"></span>
                        <span *ngIf="!rowData.trustInfo.isTrusted" class="fa-regular fa-thumbs-down" style="cursor: pointer; color: #c8102e;" (click)="trustDevice(rowData)"></span>
                        &nbsp;
                        <span *ngIf="rowData.trustInfo.expireDays < 90" style="color: darkgoldenrod;" >
                            <i class="fa-solid fa-circle-exclamation"></i>
                        </span>
                    </div>
                </td>

                <td class="text-center" [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    <div style="display: flex; justify-content: center; width: 100%; height: 30px; border-radius: 20px; border: 1px solid lightgray; padding-top: 6px; background-color: var(--kig-section-header-bg); cursor: pointer;" (click)="getDeviceIngestStats([rowData.id])">
                        <div *ngFor="let ingestStat of rowData.ingestStats; let i = index">
                            <label *ngIf="i == 0" class="css-tooltip" [attr.tooltip-data]="getIngestStatToolTipInfo(rowData, i)" style="font-size: 12px; color: black;">{{ingestStat.value}}&nbsp; - &nbsp;</label>
                            <label *ngIf="i != 0" class="css-tooltip" [attr.tooltip-data]="getIngestStatToolTipInfo(rowData, i)" style="font-size: 12px; color: black;">{{ingestStat.value}}</label>
                        </div>
                    </div>
                </td>

                <td class="modifications" [ngStyle]="{'width': columns[10].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    <div *ngIf="rowData.userFeatureAccess['EditDevice']"
                        (click)="editDevice(rowData,template)" aria-hidden="true"
                        class="fas fa-pencil-alt text-center" style="color:#64a70b; cursor: pointer; font-size: 14px;">
                    </div>
                    <div *ngIf="rowData.userFeatureAccess['ViewDevice'] && !rowData.userFeatureAccess['EditDevice']"
                        (click)="editDevice(rowData,template)" aria-hidden="true"
                        class="far fa-eye text-center" style="color:#1c4966; cursor: pointer; font-size: 14px;">
                    </div>
                </td>

                <td class="modifications" [ngStyle]="{'width': columns[11].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                    <div *ngIf="rowData.userFeatureAccess['DeleteDevice']" class="far fa-trash-alt text-center"
                        style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="onDeleteConfirm(rowData) ">
                    </div>
                </td>

            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length ">
                    Try a different search string or use * to get all gateways.
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="caption" let-rowData>
            <!-- <div style="text-align: left; height: 35px; margin-top: 10px; margin-bottom: 10px; display: flex; gap: 10px;"> -->
            <div style="text-align: left; display: flex; gap: 1em; align-items: center; margin-bottom: 0px; flex-wrap: wrap;">

                <div style="display: block; width: 170px;">
                    <label style="font-size: large; vertical-align: middle; color:black; font-weight: 500;">GATEWAYS</label>
                    <div style="display: flex; gap: 8px;" class="text-center">
                        <div style="display: block;">
                            <div style="font-size: 12px;">Displayed</div>
                            <div style="font-size: 12px;">{{ devicesDisplayed.length }}</div>
                        </div>
                        <div style="display: block;">
                            <div style="font-size: 12px;">Selected</div>
                            <div (click)="showSelectedDevices()" style="font-size: 12px; cursor: pointer;">{{ devicesCheckedCount }}</div>
                        </div>
                        <div style="display: block;">
                            <div style="font-size: 12px;">Total</div>
                            <div style="font-size: 12px;">{{ devices.length }}</div>
                        </div>
                    </div>
                </div>
                
                <form (ngSubmit)="searchGatewaysTextChanged()">
                    <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchGatewaysTextChanged()"></i>
                    <i class="fa-solid fa-magnifying-glass-minus" style="margin:4px 4px 0 0; cursor: pointer;" (click)="clearSearchFilter()"></i>
                    <input [(ngModel)]="gatewaySearchText" placeholder="Search" size="25" style="width:auto; height: 35px" type="text" name="gatewaySearchText" autocomplete="off"/>
                </form>

                <button type="button" class="btn btn-success" style="padding-top: 3px; height: 35px; margin-left: 10px;" (click)="addDevicePopUp(template)">Create Gateway</button>
                <button *ngIf="userIsAdmin || userCanUpdateGateway" type="button" class="btn btn-primary" style="padding-top: 3px; height: 35px;" (click)="openGatewayUpdateManager()">Update Gateway</button>
                <button type="button" class="btn btn-primary" style="padding-top: 3px; height: 35px;" (click)="irrigationStats()" [disabled]="!anyDeviceChecked">Irrigation Stats</button>
                <button *ngIf="userIsAdmin" type="button" class="btn btn-primary" style="padding-top: 3px; height: 35px;" (click)="openBulkChange(bulkChangeTemplate)" [disabled]="!anyDeviceChecked">Bulk Change</button>
            </div>
        </ng-template>

    </p-table>
</div>

<ng-template #loading>
    <div class="col-xs-4 col-lg-3" style="margin-top: 20px; margin-left: 20px;">
        <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
        <span style="margin-left: 20px;">Loading...</span>
    </div>
</ng-template>

<ng-template #loading2>
    <br>
    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    <span>Loading...</span>
    <br><br>
</ng-template>

<ng-template #invalidIP>
    <div>
        This device is not set up to configure water schedules or sensors.  Please configure a valid IP address in device info tab.
    </div>
</ng-template>
<ng-template #invalidIPlog>
    <br>
    <div>
        &emsp;This device is either unreachable or is not set up to view logs.
    </div>
    <br>
</ng-template>
<ng-template #tabNotUsedMsg>
    <br>
    <div>
        &emsp;&nbsp;&nbsp;Not configurable for the selected gateway type.
    </div>
    <br>
</ng-template>
<ng-template #gatewayUnreachable>
    <br>
    <div>
        &emsp;Gateway address hasn't been confirmed or the gateway is unreachable.
    </div>
    <br>
</ng-template>


<ng-template #template>
    <p-confirmDialog key="cd2" #cd2>
        <ng-template #footer>
            <button type="button" class="btn btn-success" (click)="cd2.onAccept()">Yes</button>
            <button type="button" class="btn btn-basic" (click)="cd2.onReject()">No</button>
        </ng-template>
    </p-confirmDialog>
    <!-- <form (ngSubmit)="updateDevice(device)"> -->
        <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="add-device-modal">
            <div style="background-color: #548235;  height: 7px;"></div>
            <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
                <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">{{title}}</h5>
                <button
                    (click)="firstlayermodalref.hide()"
                    class="ms-auto fas fa-times"pe="button"
                    style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
                </button>
            </div>

            <div class="modal-body">
                <div class="container-fluid" style="min-height: 600px; padding: 0px;">

                    <tabset>  
                        <tab heading="Gateway Info" active="tab.active" class="tabset" style="height: 505px;">
                            <br>

                            <div style="margin-bottom: 20px; margin-left: 20px; display: flex; gap: 20px; font-size: 15px;">
                                <div class="form-group" style="width: 400px;">
                                <label for="deviceName" style="font-weight: 500;">Name</label>
                                <input [style.color]="!duplicateName ? 'black' : 'red' " style="height: 35px; width: 400px;" type="text" id="deviceName" name="deviceName" [(ngModel)]="device.name" (ngModelChange)="duplicateNamecheck(device.name)" required />
                                </div>

                                <div class="form-group" style="width: 360px; font-size: 15px;">
                                    <label for="UserGroup" style="font-weight: 500;">Access Group</label>
                                    <ngx-select-dropdown name="userGroupSelection" style="height:32px; width: 360px; border-color: black;"
                                        [config]="userGroupconfig"
                                        [options]="associatedUserGroups"
                                        [(ngModel)]="selectedUserGroup">
                                    </ngx-select-dropdown>
                                </div>

                                <div class="form-group" style="width: 80px; margin-left: 35px; font-size: 15px;">
                                    <label style="width: 90px; font-weight: 500;" for="deviceMonitor">Monitor</label>
                                    <div style="margin-top: 8px; margin-left: 7px;">
                                        <p-toggleswitch  id="deviceMonitor" [ngModel]="!device.isDisabled" (ngModelChange)="device.isDisabled = !$event" [ngModelOptions]="{standalone: true}"
                                                (onChange)="onDeviceEnable($event)" >
                                            </p-toggleswitch>
                                    </div>
                                </div>
                            </div>

                            <div style="margin-bottom: 40px; margin-left: 20px; display: flex; gap: 20px; font-size: 15px;">
                                <div class="form-group" style="width: 780px;">
                                    <label for="description" style="font-weight: 500;">Description</label>
                                    <input type="text" style="height: 35px; width: 100%;" id="description" size="40" name="description" [(ngModel)]="device.description" required />
                                </div>
                            </div>

                            <div class="row" style="font-size: 15px;">    
                                <div class="form-group col" style="padding-left: 30px;">
                                    <table>
                                        <tr height="40px;">
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="ipaddress">*IP Address:</label>
                                            </td>
                                            <td>
                                                <label>{{device.ipAddress}}</label>
                                            </td>
                                        </tr>
                                        <tr height="40px;">  
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="macaddress">Mac Address:</label>
                                            </td>
                                            <td>
                                                <label>{{device.macAddress}}</label>
                                            </td>
                                        </tr>
                                        <tr height="40px;">
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="serialNumber">Serial#/Identifier:</label>
                                            </td>
                                            <td>
                                                 <input size="20" [style.color]="!duplicateSerial ? 'black' : 'red'" type="text" id="serialNumber" name="serialNumber" [(ngModel)]="device.serialNumber" (ngModelChange)="duplicateSerialcheck(device.serialNumber)" />
                                            </td>
                                        </tr>
                                        <tr height="40px;">  
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="mountAngle">Mounting Angle:</label>
                                            </td>
                                            <td align="left">
                                                <input size="5" type="number" id="mountAngle" name="mountAngle" [(ngModel)]="device.mountAngle" style="width: 70px;" />
                                            </td>
                                        </tr> 
                                        <tr height="40px;">  
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="mountAngle">Water Rate (GPM):</label>
                                            </td>
                                            <td align="left">
                                                <input size="5" type="number" id="waterRate" name="waterRate" [(ngModel)]="device.waterRate" style="width: 70px;" />
                                            </td>
                                        </tr>  
                                    </table>
                                </div>

                                <div class="form-group col">
                                    <table >
                                        <tr height="40px;">
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="gpslat">GPS Latitude:</label></td>
                                            <td>
                                                <input size="16" type="number" id="gpslat" name="gpslat" style="width: 200px;" [(ngModel)]="device.gpsLocation.gpsLat" />
                                            </td>
                                        </tr>
                                        <tr height="40px;">
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="gpslong">GPS Longitude:</label></td>
                                            <td>
                                                 <input size="16" type="number" id="gpslong" name="gpslong" style="width: 200px;" [(ngModel)]="device.gpsLocation.gpsLong" />
                                            </td>
                                        </tr>
                                        <tr height="40px;">  
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="gpsalt">GPS Altitude:</label></td>
                                            <td>
                                                <input size="16" type="number" id="gpsalt" name="gpsalt" style="width: 200px;" [(ngModel)]="device.gpsLocation.gpsAlt" />
                                            </td>
                                        </tr>
                                        <tr height="40px;"> 
                                            <td align="right">
                                                <label style="margin-right: 15px; font-weight: 500;" for="gpsdescription">GPS Description:</label></td>
                                            <td>
                                                <input size="16" type="text" id="gpsdescription" name="gpsdescription" [(ngModel)]="device.gpsLocation.locationDescription" />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <div *ngIf="device.userFeatureAccess['EditDevice']" style="text-align: right;">
                                <button type="button" class="btn btn-primary btn-sm" style="height: 35px; margin-right: 240px; margin-bottom: 15px;" (click)="displayHardwareInfoFromDevice(deviceHWTemplate)">Retrieve Info</button>
                            </div>
                        </tab>
                        

                        <tab heading="Sensors" id="tab1" class="tabset" style="height: 505px;">
                            <div style="display: flex; align-items: center; margin: 15px;">
                                <input type="radio" [(ngModel)]="device.mode" name="mode" value="static"> <label style="margin-left: 8px;">Static</label>
                                <input type="radio" class="dynamicButton" [(ngModel)]="device.mode" name="mode" value="dynamic"> <label style="margin-left: 8px;">Dynamic</label>
                                <button type="button" class="btn btn-primary btn-sm" style="margin-left: 350px;" (click)="showSensorsAssociations()">Show Sensor Associations</button>
                                <button type="button" class="btn btn-primary btn-sm" style="margin-left: 10px;" (click)="createOrUpdateSensorgroup()">Create Sensor Group From Current List</button>
                                <button *ngIf="BTscan && device.mode != 'dynamic'" type="button" class="revertButton btn btn-primary btn-sm" (click)="revertUUIDsBack()" style="margin-right: 10px;">Revert</button>
                                <div *ngIf="device.mode === 'dynamic'">
                                    <button type="button" class="btn btn-primary btn-sm" style="margin:20px"
                                            (click)="remoteContentViewEditLive(remoteContentEditTemplate, '/home/pi/kigs/scripts/cron/sensors.allowed' )">Allowed Sensors in Dynamic Mode</button>
                                </div>
                            </div>

                            <p-table #uuidTable [columns]="SensorGroupUUIDCols" *ngIf="device.mode === 'static'" [value]="sensorUUIDsDisplayed" [scrollable]="true" scrollHeight="23em" class="data-table-device">
                                <ng-template pTemplate="caption">
                                    <label style="color: black; font-weight: 400; margin-bottom: 5px;">Add to gateway Sensor List using the 'Search Database', 'Bluetooth Scan Area', 'From a Sensor Group' or 'QR Scan Label' options</label>
                                    <div style="display: flex; gap: 8px; align-items: center; margin-top: 10px;">
                                        <button (click)="removeUncheckedGatewaySensorList()" class="btn btn-primary btn-sm" type="button">Remove Uncheck</button>
                                        <button (click)="removeAllGatewaySensorList()" class="btn btn-primary btn-sm" type="button">Remove All</button>
                                        <form  (ngSubmit)="searchSensorsTextChanged()">
                                            <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchSensorsTextChanged()"></i>
                                            <input [(ngModel)]="sensorSearch" placeholder="Search" size="30" style="height: 35px" type="text" name="sensorSearch" autocomplete="off" />
                                        </form>
                                        <label>or</label>
                                        <button type="button" class="btn btn-primary btn-sm" [disabled]="!bluetoothScanReady(device)" (click)="bluetoothScan_ReturnRaw(device.id, device.mode, DynamicReadingtemplate)">BT Scan</button>
                                        <label>or</label>
                                        <button type="button" class="btn btn-warning btn-sm" (click)="openScanModal(scanner)" >QR Scan</button>
                                        <label>or</label>
                                        <button type="button" class="btn btn-primary btn-sm" (click)="populateGatewayListFromSensorGroup(PopupSensorGroupListTemplate)">Sensor Group</button>
                                        <label style="font-size: 15px; margin-left: 14px;">Selected: {{getCheckedSensorUUIDs()}} of {{allSensors.length}}</label>
                                    </div>

                                    <div class="text-right">
                                        <ng-template #scanner let-modal class="qrScanner">
                                          <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
                                            <div style="background-color: #548235;  height: 7px;"></div>
                                            <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
                                                <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Scan Sensors Here</h5>
                                                <button
                                                    (click)="scanModalRef.hide()"
                                                    class="ms-auto fas fa-times"pe="button"
                                                    style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
                                                </button>
                                            </div>
                                            <div class="modal-body qr-scanner-body">
                                                <kig-scanner (scanSuccess)="scanComplete($event)" (camerasFound)="camerasFound($event)" [device]="selectedDevice" id="scanZX"></kig-scanner>
                                                <br>
                                                <!-- <div class="scanSensor" id="sensorUUID">{{scannedSensor}} </div> -->

                                                <select (change)="onDeviceSelectChange($event.target.value)" style="height: 38px; width: 100%;">
                                                    <option value="" [selected]="!selectedDevice">No Device</option>
                                                    <option *ngFor="let device of availableDevices"
                                                        [value]="device.deviceId"
                                                        [selected]="selectedDevice && device.deviceId === selectedDevice.deviceId">{{ device.label }}
                                                    </option>
                                                </select>
                                                
                                                <!-- <button type="button" id="acceptButton" class="btn btn-success" (click)="addSensor()">Accept</button>
                                                <button type="button" id="ignoreButton" class="btn btn-danger" (click)="ignoreSensor()">Ignore</button> -->

                                                <div style="display: flex;">
                                                    <input type="text" [(ngModel)]="scannedSensor" name="sensorUUID" style="width: 280px; height: 35px; margin-left: 0px; margin-top: 20px; margin-right: 10px;" autofocus />
                                                    <button (click)="addSensor()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button" style="height: 35px; margin-top: 20px;">Accept</button>
                                                    <button (click)="ignoreSensor()" [disabled]="scannedSensor === ''" class="btn btn-danger" id="ignoreButton" type="button" style="height: 35px; margin-top: 20px;">Ignore</button>
                                                </div>
                                            </div>
                                          </div>
                                        </ng-template>

                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                            <div *ngIf="col.field == 'checkbox'" (click)="toggleCheckedSensorsDisplayed()" style="padding-left: 2px; font-size: 22px;">▣</div>
                                            {{col.header}}
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                                    <tr style="height: 40px;">
                                        <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                            <p-checkbox id="{{rowData.uuid + i}}" name="{{rowData.uuid + i}}" [(ngModel)]="rowData.checked" binary="true"></p-checkbox>
                                        </td>

                                        <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                            {{ rowData.name }}
                                        </td>

                                        <td [ngStyle]="{'width': columns[2].width}" style="cursor: pointer; flex: none; border-width: 0px;"> 
                                            <div style="cursor: pointer; display: flex;">
                                                <div (click)="showSensorLabelModal(rowData.uuid)" class="kig-link">
                                                    {{ rowData.uuid }}
                                                </div> 
                                                <div class="fas fa-chart-line kig-link" (click)="showSensorDataPreviewForSensor(rowData)" style="cursor: pointer; font-size: 16px; margin-left: 10px; width: 10%;"></div>  
                                            </div>
                                        </td>

                                        <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                            <div *ngIf="rowData.lastReading.waitingForLoad">
                                                <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                                            </div>
                                            <div *ngIf="!rowData.lastReading.waitingForLoad && rowData.lastReading.isLoaded" [ngStyle]="{'color': rowData.lastReading.displayColor }">
                                                <i class="fa-solid fa-square"></i>
                                                {{ rowData.lastReading.date | date: 'medium' }}
                                            </div>
                                        </td>

                                        <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                            {{ rowData.type }}
                                        </td>
                                        
                                        <td class="text-center" [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                                            <div *ngIf="rowData.checked" style="float: left; margin-top: 5px;">
                                                <div *ngIf="retrievingGatewaySensorInfo">
                                                    <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                                                </div>
                                                <div  *ngIf="!retrievingGatewaySensorInfo">
                                                    <div *ngIf="getDeviceSensorSyncStatus(rowData.uuid) === 'yes'"  [ngStyle]="{'color': getDeviceSensorSyncColor(rowData.uuid)}" class="css-tooltip3" [attr.tooltip-data]="'Sensor is synced with gateway'"><i class="fa-solid fa-check"></i></div>
                                                    <div *ngIf="getDeviceSensorSyncStatus(rowData.uuid) === '?'"  [ngStyle]="{'color': getDeviceSensorSyncColor(rowData.uuid)}" class="css-tooltip3" [attr.tooltip-data]="'Sync status unknown or not synced'">?</div>
                                                    <!-- {{ getDeviceSensorSyncStatus(rowData.uuid) }} -->
                                                </div>
                                            </div>
                                            <button *ngIf="sensorHasBlinkNowCapability(rowData)" (click)="blinkSensorNow(rowData)" class="btn-basic css-tooltip2" [attr.tooltip-data]="'Blink sensor'" style="color: #5c8f3a; cursor: pointer; font-size: 15px; border: none; background-color: transparent; height: 28px; float: right; margin-top: -2px;" ><i class="fa-regular fa-lightbulb"></i></button>
                                        </td>

                                    </tr>
                                </ng-template>
                            </p-table>

                            <label style="font-size: 14px; margin-left: 10px; margin-right: 10px;">Last Reading Color Key:</label>
                            <label style="font-size: 14px; margin-right: 10px; color: #64a70b"><i class="fa-solid fa-square"></i> Day,</label>
                            <label style="font-size: 14px; margin-right: 10px; color: #dadb26"><i class="fa-solid fa-square"></i> Week,</label>
                            <label style="font-size: 14px; margin-right: 10px; color: #ff9551"><i class="fa-solid fa-square"></i> Month,</label>
                            <label style="font-size: 14px; margin-right: 10px; color: purple"><i class="fa-solid fa-square"></i> 6 Months,</label>
                            <label style="font-size: 14px; margin-right: 10px; color: #f93232"><i class="fa-solid fa-square"></i> 6+ Months</label>
                        </tab>
                            
                        <tab heading="Irrigation Schedules" class="tabset" style="height: 505px;">
                            <div>
                                <br>
                                 <p-table #irrigationScheduleTable [columns]="IrrigationCols" [value]="globalWaterSchedules" [scrollable]="true" scrollHeight="30em" class="irrigation-table-device">
                                    <ng-template pTemplate="caption" let-rowData>
                                        <div style="text-align: left">
                                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                                            <input type="text" InputText size="50" placeholder="Search" (input)="irrigationScheduleTable.filterGlobal($event.target.value, 'contains')" style="width:200px">
                                            <button type="button" class="btn btn-primary" style="float: right; margin-right: 10px; margin-top: -4px;" (click)="addIrrSchedule(irrigationtemplate)">Create</button>
                                            <!-- <button type="button" class="btn btn-primary" style="float: right; margin-right: 5px; margin-top: -4px;" (click)="launchIrrigationLogs(irrlogTemplate)">Device Irrigation Logs</button>&nbsp; -->
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage" let-columns>
                                        <tr>
                                            <td [attr.colspan]="columns.length">
                                                No schedules found. Try a different search.
                                                
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.header=='Name' || col.header=='Owner'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                                        <tr style="height: 40px;">
                                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                                <div class="text-left">
                                                    {{rowData.name}}
                                                </div>
                                            </td>
                                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                                <div *ngIf="rowData.isSelfOwned" class="text-left" (click)="showWaterScheduleOwners(rowData, waterScheduleOwnerTemplate)" style="cursor: pointer; "  [style.color]="!rowData.ownerChanged ? 'rgb(0, 123, 255)' : 'red' ">
                                                    {{ rowData.ownerName }}
                                                </div>   
                                                <div *ngIf="!rowData.isSelfOwned" class="text-left">
                                                        {{ rowData.ownerName }}
                                                </div>                                             
                                            </td>
                                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                                <div class="text-center">
                                                    {{rowData.cycles}}
                                                </div>
                                            </td>
                                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                                <div class="text-center">
                                                    {{rowData.timeOn}}
                                                </div>
                                            </td>
                                            <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                                <div class="text-center">
                                                    {{rowData.timeOff}}
                                                </div>
                                            </td>
                                            <td [ngStyle]="{'width': columns[5].width}" [style.color]="'blue'" style="flex: none; border-width: 0px;">
                                                <div class="text-center" (click)="showWaterScheduleUsage(rowData, waterScheduleUsageTemplate)" style="cursor: pointer; color: rgb(0, 123, 255);">
                                                    {{rowData.usedByCount}}
                                                </div>
                                            </td>
                                            <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                                                <div class="text-center" *ngIf="rowData.isSelfOwned">
                                                    <div class="fas fa-pencil-alt" style="color:#64a70b; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="editIrrSchedule(rowData, irrigationtemplate)"></div>
                                                    <span class="sr-only ">Edit</span>
                                                </div>
                                            </td>
                                            <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                                                <div class="text-center" *ngIf="rowData.isSelfOwned && rowData.usedByCount < 1">
                                                    <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="deleteIrrSchedule(rowData, preWaterScheduleDeleteTemplate)"></div>
                                                    <span class="sr-only ">Delete</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </tab>
                            
                        <tab heading="Cloud Storage" class="tabset" style="height: 505px;">
                            <div *ngIf="!loadingCloudStorageFileList; else loading">
                                <label style="margin-left: 15px; font-weight: 500;">Upload File</label>
                                <input type="file" id="file" accept=".zip" (change)="fileSelectedForUpload($event.target.files)" style="margin: 15px; width: 700px;">

                                <p-table #cloudStorageTable [columns]="cloudStorageCols" [value]="availableCloudFiles" [scrollable]="true" scrollHeight="26em" class="data-table-device">
                                    <ng-template pTemplate="caption">
                                        <div style="text-align: left; height: 50px; display: flex; align-items: center; ">
                                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                                            <input type="text" pInputText size="35" placeholder="Search" (input)="cloudStorageTable.filterGlobal($event.target.value, 'contains')" style="width:auto; height: 30px">

                                            <div *ngIf="selectedCloudFiles.length > 0" style="display: flex; margin-left: 495px;">
                                                <div class="fa-solid fa-cloud-arrow-down" pTooltip="Download checked files to gateway" tooltipPosition="top"
                                                    style="color: #64a70b; cursor: pointer; font-size: 14px; margin-right: 30px;" aria-hidden="true" (click)="onFileDownloadCheckedToGateway() ">
                                                </div>
                                                <div class="fa-solid fa-cloud-arrow-down" pTooltip="Download checked files to desktop" tooltipPosition="top"
                                                    style="color: blue; cursor: pointer; font-size: 14px; margin-right: 30px;" aria-hidden="true" (click)="onFileDownloadCheckedToDesktop() ">
                                                </div>
                                                <div class="far fa-trash-alt text-center" pTooltip="Delete checked file(s)" tooltipPosition="top"
                                                    style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true" (click)="onFileDeleteCheckedConfirm() ">
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                                <div *ngIf="col.field == 'checked'" (click)="toggleCheckedCloudFiles()" style="padding-left: 2px; font-size: 20px;">▣</div>
                                                {{col.header}}
                                            </th>
                                        </tr>
                                    </ng-template>
                
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                                        <tr style="height: 40px;">
                                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                                                <p-checkbox [(ngModel)]="rowData.checked" binary="true" id="{{rowData.name}}" name="{{rowData.name}}" [ngModelOptions]="{standalone: true}" (ngModelChange)="cloudFileCheckedChanged(rowData)" [disabled]="device.userFeatureAccess['EditDevice'] == false"></p-checkbox>
                                            </td>

                                            <td [ngStyle]="{'width': columns[1].width}" style="cursor: pointer; flex: none; border-width: 0px;">
                                                {{ rowData.name }}
                                            </td>
                
                                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                                {{ rowData.uploadDate | date : 'medium' }}
                                            </td>
                                            
                                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                                <div class="fa-solid fa-cloud-arrow-down" pTooltip="Download to Gateway" tooltipPosition="top"
                                                    style="color: #64a70b; cursor: pointer; font-size: 14px;" aria-hidden="true" (click)="onFileDownloadToGateway(rowData, device.serialNumber) ">
                                                </div>
                                            </td>
                
                                            <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                                <div class="fa-solid fa-cloud-arrow-down" pTooltip="Download to Desktop" tooltipPosition="top"
                                                    style="color: blue; cursor: pointer; font-size: 14px;" aria-hidden="true" (click)="onFileDownloadToDesktop(rowData, device.serialNumber) ">
                                                </div>
                                            </td>

                                            <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                                                <div class="far fa-trash-alt text-center" pTooltip="Delete file" tooltipPosition="top"
                                                    style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true" (click)="onFileDeleteConfirm(rowData, device.serialNumber) ">
                                                </div>
                                            </td>
                
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>            
                        </tab>

                        <tab heading="Advanced" class="tabset" style="font-size: 15px; height: 505px;">
                            <br>
                            <div style="margin: 10px; display: flex; gap: 10px;">
                                <label style="margin-right: 5px; margin-top: 5px; margin-bottom: 10px;" for="Command">Quick Links:</label>
                                <ng-select [items]=gatewayCommands
                                    name="GatewayCommands"
                                    style="width: 680px;"
                                    bindLabel="name"
                                    (change) = "gatewayCommandSelectionChanged($event)"
                                    placeholder = "Select Command"
                                    [(ngModel)]="gatewayCommandSelected"
                                    groupBy="category">
                                </ng-select>

                                <button type="button" class="btn-sm" style="margin-left:10px; color: black; border-radius: 5px; border: solid 1px darkgrey;font-size: 14px; width: 70px;" (click)="executeLiveCommand(commandTemplate, '', '', 'Starting task')">Execute</button>
                            </div>
                            <label style="margin-right: 20px; margin-left: 10px; margin-bottom: 5px; width: 870px;">Description: &nbsp; &nbsp; {{ gatewayCommandSelected.description }} </label>
 
                            <!-- <div *ngIf="userIsAdmin" class="form-group" style="margin-left: 10px; margin-bottom: 20px;"> -->
                            <div class="form-group" style="margin-left: 10px; margin-bottom: 20px;">
                                <hr>
                                <div style="margin-bottom: 10px;">
                                    <label style="margin-right: 20px; margin-top: 5px;">Command: </label>
                                    <input style="text-align:left; height: 35px; width: 530px;" type="text" id="Command" name="Command" [(ngModel)]="gatewayLiveCommand" />
                                    <button type="button" class="btn-sm" style="margin-left:10px; color: black; border-radius: 5px; border: solid 1px darkgrey; font-size: 14px; width: 70px;" (click)="executeLiveCommand(commandTemplate, '', '', 'Starting task')">Execute</button>
                                    <button type="button" class="btn-sm" style="margin-left:10px; color: black; border-radius: 5px; border: solid 1px darkgrey; font-size: 14px; width: 50px;" (click)="remoteContentViewEditLive(remoteContentEditTemplate, gatewayLiveCommand )">Edit</button>
                                    <button type="button" class="btn-sm" style="margin-left:10px; color: black; border-radius: 5px; border: solid 1px darkgrey; font-size: 14px; width: 140px;" (click)="startIotDirectConnection(device, IotDirectTemplate )">Direct Commands</button>
                                </div>
                            </div>
                        </tab>

                        <tab heading="Scoutview" class="tabset" style="height: 505px;">
                            <br>
                            <div style="padding: 8px; font-size: 14px;">
                                <table style="width: 100%;">
                                  <tr *ngFor="let camera of device.deviceCameras; let i = index; let firstel = first; let lastel = last">
                                    <td>
                                      <div class="form-group" style="width:240px; margin-bottom: 5px;">
                                        <label *ngIf="i==0" for="{{'CameraName' + i}}" style="font-size: 14px; font-weight: 500;">Name</label>
                                        <input [(ngModel)]="camera.name" class="form-control" id="{{'CameraName' + i}}" name="{{'CameraName' + i}}" required type="text" style="height: 34px; font-size: 14px; padding-top: 2px;">
                                      </div>
                                    </td>
              
                                    <td>
                                      <div class="form-group" style="width:140px">
                                        <label *ngIf="i==0" for="{{'CameraType' + i}}" style="font-size: 14px; font-weight: 500;">Type</label>
                                        <ngx-select-dropdown name="{{'CameraType' + i}}" [config]="CameraDDConfig" [options]="CameraTypeDDOptions" [(ngModel)]="camera.type" ></ngx-select-dropdown>
                                      </div>
                                    </td>
              
                                    <td>
                                        <div class="form-group" style="width:280px">
                                          <label *ngIf="i==0" for="{{'CameraModel' + i}}" style="font-size: 14px; font-weight: 500;">Camera Model</label>
                                          <ngx-select-dropdown name="{{'CameraModel' + i}}" [config]="CameraDDConfig" [options]="CameraModelDDOptions" [(ngModel)]="camera.model" ></ngx-select-dropdown>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-group" style="width: 120px;">
                                          <label *ngIf="i==0" for="{{'CameraPort' + i}}" style="font-size: 14px; font-weight: 500;">IP Address</label>
                                          <input [(ngModel)]="camera.port" class="form-control" id="{{'CameraPort' + i}}" name="{{'CameraPort' + i}}" required type="text" style="height: 34px; font-size: 14px; padding-top: 2px;">
                                        </div>
                                    </td>

                                    <!-- <td style="width:150px">
                                        <div class="form-group">
                                          <label *ngIf="i==0" for="{{'CameraLogin' + i}}" style="font-size: 14px; font-weight: 500;">Login (user:pass)</label>
                                          <input [(ngModel)]="camera.login" class="form-control" id="{{'CameraLogin' + i}}" name="{{'CameraLogin' + i}}" required type="text" style="height: 34px; font-size: 14px;">
                                        </div>
                                    </td> -->
           
                                    <td style="width:15px"></td>
              
                                    <td style="width: 50px; color: #5279bc" class="modifications">
                                      <label *ngIf="i==0" for="{{'AddCamera' + i}}"><br></label>
                                      <div *ngIf="!lastel" class="text-left">
                                        <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delCamera(i) "></div>
                                      </div>
                                      <div *ngIf="lastel" class="text-left">
                                        <span class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delCamera(i) "></span>
                                        <span class="fas fa-plus pull-right" style="font-size: 18px; margin-top: 1px" aria-hidden="true " (click)="addCamera()"></span>
                                      </div>
                                    </td>
                                  </tr>
              
                                  <tr *ngIf="device.deviceCameras.length==0">
                                    <td style="width:30px; color: #5279bc; padding-left: 10px; padding-bottom: 10px;" class="modifications">
                                      <div class="fas fa-plus" aria-hidden="true " (click)="addCamera()"></div>
                                      <span class="sr-only">Plus</span>
                                      <br>
                                    </td>
                                  </tr>
              
                                </table>
                            </div>
                        </tab>

                        <tab heading="Gateway Logs" class="tabset" style="height: 505px;">
                            <div style="height: 100%; display: flex; flex-direction: column;">
                                <div style="padding: 10px; display: flex; gap: 10px; font-size: 15px; align-items: center; flex-wrap: wrap; border-bottom: 1px solid #e0e0e0; flex: 0 0 auto;">
                                    <label style="font-weight: 500; margin: 0; line-height: 30px;">Gateway Logs</label>
                                    <label *ngIf="device.updateMessages?.length" style="font-weight: 400; margin: 0; line-height: 30px; color: #666; font-size: 13px;">({{filteredDeviceMessages?.length}}<span *ngIf="gatewayLogSearchText"> of {{device.updateMessages.length}}</span>)</label>
                                    <button (click)="getGatewayActivityMessages(device, 0)" class="btn btn-basic" style="color: blue; font-size: 15px; padding: 0; height: 30px; line-height: 30px;" type="button"><i class="fa-solid fa-arrows-rotate"></i></button>
                                    <i class="fa fa-search" style="line-height: 30px; margin-top: 5px;"></i>
                                    <input [(ngModel)]="gatewayLogSearchText" placeholder="Search messages" size="20" style="height: 30px;" type="text" name="gatewayLogSearchText" autocomplete="off" />
                                    <i *ngIf="gatewayLogSearchText" class="fa-solid fa-magnifying-glass-minus" style="cursor: pointer; line-height: 30px;" (click)="gatewayLogSearchText = ''"></i>
                                    <div style="display: flex; align-items: center; gap: 3px; margin-left: 10px;">
                                        <label style="font-weight: 500; margin: 0; line-height: 30px;">Dates</label>
                                        <input type="text" ngxDaterangepickerMd [(ngModel)]="gatewayLogDateRange" name="gatewayLogDateRange" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [linkedCalendars]="true" [isInvalidDate]="isInvalidDate" [showClearButton]="true" (datesUpdated)="getGatewayMessagesByDateRange(device)" placeholder="Select Date Range" autocomplete="off" style="height: 30px; width: 210px;" />
                                    </div>
                                    <label style="font-weight: 500; margin: 0; line-height: 30px;">Load</label>
                                    <button (click)="getGatewayActivityMessages(device, 10)" class="btn btn-basic" style="color: blue; font-size: 14px; padding: 0; height: 30px; line-height: 30px;" type="button">10</button>
                                    <button (click)="getGatewayActivityMessages(device, 100)" class="btn btn-basic" style="color: blue; font-size: 14px; padding: 0; height: 30px; line-height: 30px;" type="button">100</button>
                                    <button (click)="getGatewayActivityMessages(device, 500)" class="btn btn-basic" style="color: blue; font-size: 14px; padding: 0; height: 30px; line-height: 30px;" type="button">500</button>
                                    <div style="margin-left: auto; display: flex; gap: 10px; align-items: center;">
                                        <button *ngIf="device.userFeatureAccess['EditDevice']" (click)="deleteAllGatewayMessages(device)" [disabled]="!device.updateMessages?.length" class="btn btn-basic" style="color: #c8102e; font-size: 14px; padding: 0 6px; height: 30px; line-height: 30px;" type="button"><i class="far fa-trash-alt"></i> Selected</button>
                                    </div>
                                </div>

                                <div *ngIf="gatewayLogsLoading" style="flex: 1 1 auto; min-height: 0; display: flex; align-items: center; justify-content: center;">
                                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                                </div>
                                <div *ngIf="!gatewayLogsLoading && device.updateMessages != undefined" style="flex: 1 1 auto; min-height: 0; overflow-y: auto; font-size: 15px; white-space: pre-wrap; padding: 10px 10px 0 10px;">
                                    <div *ngFor="let update of filteredDeviceMessages" style="font-size: 14px;">{{update.createdDate | date : 'medium' }}: &nbsp; &nbsp; <span [innerHTML]="update.message | highlight:gatewayLogSearchText"></span></div>
                                </div>
                            </div>
                        </tab>

                        <tab *ngIf="userIsAdmin" heading="Security" class="tabset" style="height: 505px;">
                            <div style="padding: 20px; font-size: 14px; height: 100%; overflow-y: auto; box-sizing: border-box;">
                                <label style="font-size: 15px; margin-bottom: 5px;">Gateway Access to Bearer Token Secured APIs</label>
                                <p style="margin-left: 20px; margin-bottom: 20px; color: #444;">Note: Ingest APIs (single and Bulk) are enabled by default when the Gateway is in "trusted" mode</p>

                                <!-- Preset gateway types: selecting one sets the checkboxes below to that
                                     preset's functions; 'Custom' leaves the selection unchanged. The radio is
                                     derived from the current selection, so it is not saved -- only the checkboxes. -->
                                <div style="display: flex; gap: 22px; align-items: center; flex-wrap: wrap; margin-bottom: 18px;">
                                    <label style="font-weight: 500; margin: 0;">Gateway Type:</label>
                                    <label *ngFor="let preset of gatewayFunctionPresets" style="display: inline-flex; align-items: center; gap: 5px; margin: 0; cursor: pointer;">
                                        <input type="radio" name="gatewayPreset" [checked]="selectedGatewayPreset === preset.label" (change)="applyGatewayPreset(preset.label)" />
                                        {{ preset.label }}
                                    </label>
                                    <label style="display: inline-flex; align-items: center; gap: 5px; margin: 0; cursor: pointer;">
                                        <input type="radio" name="gatewayPreset" [checked]="selectedGatewayPreset === customGatewayPresetLabel" (change)="applyGatewayPreset(customGatewayPresetLabel)" />
                                        Custom
                                    </label>
                                </div>

                                <table style="width: 100%; border-collapse: collapse;">
                                    <thead>
                                        <tr style="text-align: left; border-bottom: 1px solid #ccc;">
                                            <th style="width: 80px; padding: 6px 10px; text-align: center;">
                                                Enabled
                                                <div (click)="toggleAllDeviceFunctions()" title="Check/uncheck all" style="cursor: pointer; font-size: 17px; line-height: 1;">▣</div>
                                            </th>
                                            <th style="width: 264px; padding: 6px 10px;">API Name</th>
                                            <th style="padding: 6px 10px;">API Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let deviceFunction of deviceFunctions" style="border-bottom: 1px solid #f0f0f0;">
                                            <td style="padding: 6px 10px; text-align: center;">
                                                <input type="checkbox" [checked]="isDeviceFunctionChecked(deviceFunction.id)" (change)="toggleDeviceFunction(deviceFunction.id)" />
                                            </td>
                                            <td style="padding: 6px 10px;">{{ deviceFunction.name }}</td>
                                            <td style="padding: 6px 10px;">{{ deviceFunction.description }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </tab>
                    </tabset>

                    <div *ngIf="showGatewayMessages" style="border: 1px solid lightgray; margin-top: 10px;">
                        <div style="padding: 10px; display: flex; gap: 10px; font-size: 15px; align-items: center; flex-wrap: wrap; border-bottom: 1px solid #e0e0e0;">
                            <label style="font-weight: 500; margin: 0; line-height: 30px;">Gateway Logs</label>
                            <label *ngIf="device.updateMessages?.length" style="font-weight: 400; margin: 0; line-height: 30px; color: #666; font-size: 13px;">({{filteredDeviceMessages?.length}}<span *ngIf="gatewayLogSearchText"> of {{device.updateMessages.length}}</span>)</label>
                            <button (click)="getGatewayActivityMessages(device, 0)" class="btn btn-basic" style="color: blue; font-size: 15px; padding: 0; height: 30px; line-height: 30px;" type="button"><i class="fa-solid fa-arrows-rotate"></i></button>
                            <i class="fa fa-search" style="line-height: 30px;"></i>
                            <input [(ngModel)]="gatewayLogSearchText" placeholder="Search messages" size="20" style="height: 30px;" type="text" name="gatewayLogSearchText2" autocomplete="off" />
                            <i *ngIf="gatewayLogSearchText" class="fa-solid fa-magnifying-glass-minus" style="cursor: pointer; line-height: 30px;" (click)="gatewayLogSearchText = ''"></i>
                            <div style="display: flex; align-items: center; gap: 3px; margin-left: 10px;">
                                <label style="font-weight: 500; margin: 0; line-height: 30px;">Dates</label>
                                <input type="text" ngxDaterangepickerMd [(ngModel)]="gatewayLogDateRange" name="gatewayLogDateRange2" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [linkedCalendars]="true" [isInvalidDate]="isInvalidDate" [showClearButton]="true" (datesUpdated)="getGatewayMessagesByDateRange(device)" placeholder="Select Date Range" autocomplete="off" style="height: 30px; width: 210px;" />
                            </div>
                            <label style="font-weight: 500; margin: 0; line-height: 30px;">Load</label>
                            <button (click)="getGatewayActivityMessages(device, 10)" class="btn btn-basic" style="color: blue; font-size: 14px; padding: 0; height: 30px; line-height: 30px;" type="button">10</button>
                            <button (click)="getGatewayActivityMessages(device, 100)" class="btn btn-basic" style="color: blue; font-size: 14px; padding: 0; height: 30px; line-height: 30px;" type="button">100</button>
                            <button (click)="getGatewayActivityMessages(device, 500)" class="btn btn-basic" style="color: blue; font-size: 14px; padding: 0; height: 30px; line-height: 30px;" type="button">500</button>
                            <div style="margin-left: auto; display: flex; gap: 10px; align-items: center;">
                                <button *ngIf="device.userFeatureAccess['EditDevice']" (click)="deleteAllGatewayMessages(device)" [disabled]="!device.updateMessages?.length" class="btn btn-basic" style="color: #c8102e; font-size: 14px; padding: 0 6px; height: 30px; line-height: 30px;" type="button"><i class="far fa-trash-alt"></i> Selected</button>
                            </div>
                        </div>

                        <div *ngIf="gatewayLogsLoading" style="height: 11em; display: flex; align-items: center; justify-content: center;">
                            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        </div>
                        <div *ngIf="!gatewayLogsLoading && device.updateMessages != undefined" style="height: 11em; overflow-y: scroll; font-size: 15px; white-space: pre-wrap; padding: 10px 10px 0 10px;">
                            <div *ngFor="let update of filteredDeviceMessages" style="font-size: 14px;">{{update.createdDate | date : 'medium' }}: &nbsp; &nbsp; <span [innerHTML]="update.message | highlight:gatewayLogSearchText"></span></div>
                        </div>
                    </div>          

                    <div *ngIf="device.userFeatureAccess['EditDevice']" style="margin-top: 15px;">
                        <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
                        <button (click)="updateDevice(device)" class="btn btn-success col-xs-5 pull-right" style="margin-right: 20px;" type="button">{{buttonValue}}</button>
                        <button (click)="firstlayermodalref.hide()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 15px;" type="button">Cancel</button>
                        <button (click)="showGatewayMessageBox()" class="btn btn-primary col-xs-5 pull-left" style="margin-right: 15px; margin-bottom: 15px;" type="button">{{ showGatewayMessages ? 'Hide Gateway Logs' : 'Show Gateway Logs' }}</button>
                    </div>
                </div>
            </div>
        </div>
    <!-- </form> -->
</ng-template>


<ng-template #commandTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="command-modal">
    <!-- <div class="modal-content command-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 [style.color]="'#0072ce'" class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Command Results</h5>
            <button
                (click)="logModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
        <div class=" modal-body" [ngStyle]="{'background-color':'#292828'}">
            <label class="commandLabel" [ngStyle]="{'color':'#f9faf2'}" style="text-align:left">{{gatewayLiveCommandResults}}</label>
        </div>
    </div>
</ng-template>


<ng-template #remoteContentEditTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="command-modal">
    <!-- <div class="modal-content command-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5  class="modal-title pull-left" style="color:black; text-transform: none;">View & Edit Content - {{remoteContentReference}}</h5>
            <!-- <button type="button" class="close pull-right" aria-label="Close" (click)="logModalRef.hide()"><span
                aria-hidden="true">&times;</span></button> -->
            <button
                (click)="logModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
            </button>
        </div>
        <div class="modal-body" [ngStyle]="{'background-color':'#595959'}"> 
            <div>
                <textarea [(ngModel)]="uploadFileContent" style="width: 970px; height: 300px; background-color: rgb(35, 35, 35); color: white;" type="text" name="uploadContent" ></textarea>
            </div>
            <div style="height: 35px; margin-bottom: 15px; ">
                <button type="button" class="btn btn-info" (click)="loadFileContentFromDevice()" style="margin-right: 10px; margin-bottom: 6px;">Reload</button>
                <label style="margin-left: 30px; color: white">{{ uploadFileContent.length }} Characters</label>
                <button type="button" class="btn btn-info pull-right" (click)="saveContentToDevice()" [disabled]="remoteFileContentSaveCommands.length < 1" style="margin-top: 10px;">Save</button>
                <button type="button" class="btn btn-info pull-right" (click)="restoreContentToDevice()" [disabled]="remoteFileContentRestoreCommands.length < 1" style="margin-right: 10px; margin-top: 10px;">Restore Original</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #waterScheduleUsageTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="std500px-modal">
    <!-- <div class="model-content std500px-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Events and Actions using Schedule</h5>
        </div>
        <div class="modal-body" style="max-height: 600px; overflow-y: scroll; background-color: white;">
            <table class="table">
                <tr *ngFor="let trigger of currentWaterScheduleUsage; let i = index" style="line-height: 1.2;">
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;{{trigger}}</td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>


<ng-template #waterScheduleOwnerTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="std500px-modal">
    <!-- <div class="model-content std500px-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Select device to assign as new owner</h5>
            <button
                (click)="wsModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <table class="table">
            <tr *ngFor="let deviceName of currentDevices; let i = index">
                <td>
                    <div (click)="assignOwnerToCurrentWaterSchedule(deviceName)" style="margin-left: 20px; cursor: pointer; color: rgb(0, 123, 255);">
                        {{deviceName}}
                    </div>
                </td>
            </tr>
        </table>
    </div>
</ng-template>
    

<ng-template #irrigationtemplate>
    <form (ngSubmit)="updateWaterScheduleCycleOnOffValues(selectedWaterSchedule)">
        <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="edit-waterschedule-modal">
        <!-- <div class="modal-content edit-waterschedule-modal"> -->
            <div style="background-color: #548235;  height: 7px;"></div>
            <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">  
                <div class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none; margin-top: 5px;"><h5 style="text-transform: none;">Schedule: {{selectedWaterSchedule.name}}</h5></div><br>&nbsp;&nbsp;
                <button
                    (click)="secondlayermodalref.hide()"
                    class="ms-auto fas fa-times"pe="button"
                    style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
                </button>
            </div>

            <div class="modal-body">
                <div>
                    <label style="margin-top: 20px; margin-left: 10px; margin-right: 10px; margin-bottom: 20px;">Name: </label>
                    <input type="text" size="35" class="col-xs-2" [style.color]="!duplicateWaterSchedulename ? 'black' : 'red' " name="schedulename" [(ngModel)]="selectedWaterSchedule.name" (ngModelChange)="duplicateWSname(selectedWaterSchedule.name)" required />
                </div>

                <table style="margin-left: 10px;">
                    <tr *ngFor="let WS of selectedWaterSchedule.timerRounds; let in = index; let firstel = first; let lastel = last " height="40px">
                        <td style="width:80px" align="right">
                            <label style="margin-right: 10px;" for="On">On:</label></td>
                        <td style="width:120px">
                            <input style="width: 60px;" type="number" name="On{{WS.id}}" [(ngModel)]="WS.on" min="1" required />&nbsp;sec</td>
                        <td style="width:80px" align="right">
                            <label style="margin-right: 10px;" for="Off">Off:</label></td>
                        <td style="width:120px">
                            <input style="width: 60px;" type="number" name="Off{{WS.id}}" [(ngModel)]="WS.off" min="0" required />&nbsp;sec</td>
                        <td style="width:150px" align="right">
                            <label style="margin-right: 10px;" for="Multiplier">Cycles:</label></td>
                        <td style="width:100px">
                            <input style="width: 50px;" type="number" name="Multiplier{{WS.id}}" [(ngModel)]="WS.multiplier" min="1" required /></td>
                        <td style="width:50px" class="modifications">
                            <div *ngIf="in > 0" class="text-left">
                                <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="deleteWSrow(selectedWaterSchedule, in) "></div>
                                <span class="sr-only ">Delete</span>
                            </div>
                        </td>
                        <td style="width:50px" class="modifications">
                            <div *ngIf="lastel && WS.on != null && WS.off != null && WS.multiplier != null" class="text-left">
                                <div class="fas fa-plus" aria-hidden="true " (click)="addWSrow(selectedWaterSchedule) "></div>
                                <span class="sr-only ">Plus</span>
                            </div>
                        </td>
                    </tr>
                </table>
                <hr>
                <div>
                    <button type="submit" [disabled]="duplicateWaterSchedulename" class="btn btn-success col-xs-5 pull-right" style="margin-right: 20px;">{{irrigationButton}}</button>
                    <br>
                </div>
                <br>  
            </div>
        </div>

    </form>

</ng-template>


<ng-template #DynamicReadingtemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
    <!-- <div class="modal-content"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Available Scanned Sensors</h5>
            <!-- <button type="button" class="close pull-right" aria-label="Close" (click)="secondlayermodalref.hide()"><span aria-hidden="true" style="padding-left:0px">&times;</span></button> -->
            <button
                (click)="secondlayermodalref.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
        <p-table #uuidTable [columns]="ScannedSensorCols" [value]="scannedSensors" [scrollable]="true" scrollHeight="25em" class="scannedSensor-table-device">
            <ng-template pTemplate="caption">
                <div style="text-align: left">
                    <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                    <input type="text" InputText size="50" placeholder="Search" (input)="uuidTable.filterGlobal($event.target.value, 'contains')" style="width:auto">
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg);">
                        {{col.header}}
                        <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" class="data-acquisition">
                <tr>
                    <td [ngStyle]="{'width': columns[0].width}">
                        {{rowData.name}}
                    </td>
                    <td [ngStyle]="{'width': columns[1].width}">
                        {{rowData.uuid}}
                    </td>
                    <td [ngStyle]="{'width': columns[2].width}">
                        {{rowData.type}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</ng-template>


<ng-template #syslogTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="logs-modal shadow-lg bg-white rounded">
    <!-- <div class="modal-content logs-modal shadow-lg bg-white rounded"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">System Logs from {{device.name}}</h5>
            <button
                (click)="logModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
        <div class=" modal-body">
            <div class="row ">
                <div class="col-xs-7 col-md-8 event-log-cal " style="margin: 5px ">
                    <input type="text " ngxDaterangepickerMd [(ngModel)]="selectedDateRange " [showCustomRangeLabel]="true " [alwaysShowCalendars]="true " [ranges]="ranges " [linkedCalendars]="true " [isInvalidDate]="isInvalidDate " [showClearButton]="true" (datesUpdated)="datesUpdated($event) "
                        placeholder="Select Date Range " autocomplete="off" />
                </div>
            </div>
        </div>
        <div>
            <tabset *ngIf="this.startDate != null && this.endDate != null">
                <p-table #sysLogTable [exportFunction]="exportCsv" [columns]="eventLogCols" [value]="deviceLogs" sortField="createdDate" *ngIf="awaitSystemLogs; else loading2">
                    <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                            <button class="btn btn-success" (click)="sysLogTable.exportCSV()">
                                <span class="glyphicon glyphicon-export smf-vertical-align-content"></span> &nbsp; Export
                            </button>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="text-center" style="background-color: var(--kig-section-header-bg);">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td class="text-center" width="30%">
                                {{rowData.date | date : 'medium'}}
                            </td>
                            <td class="text-center">
                                {{rowData.msg}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </tabset>
        </div>
    </div>
</ng-template>


<ng-template #irrlogTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="logs-modal">
    <!-- <div class="modal-content logs-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Irrigation Logs from {{device.name}}</h5>
            <button
                (click)="logModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
        <div class=" modal-body">
            <div class="row ">
                <div class="col-xs-7 col-md-8 event-log-cal " style="margin: 5px ">
                    <input type="text " ngxDaterangepickerMd [(ngModel)]="selectedDateRange " [showCustomRangeLabel]="true " [alwaysShowCalendars]="true " [ranges]="ranges " [linkedCalendars]="true " [isInvalidDate]="isInvalidDate " [showClearButton]="true" (datesUpdated)="datesUpdated($event) "
                        placeholder="Select Date Range " autocomplete="off" />
                </div>
            </div>
        </div>
        <div>
            <tabset *ngIf="this.startDate != null && this.endDate != null">
                <p-table #irrLogTable [exportFunction]="exportCsv" [columns]="eventLogCols" [value]="deviceLogs" sortField="createdDate" *ngIf="awaitIrrigationLogs; else loading2">
                    <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                            <button class="btn btn-success" (click)="irrLogTable.exportCSV()">
                                <span class="glyphicon glyphicon-export smf-vertical-align-content"></span> &nbsp; Export
                            </button>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="text-center" style="background-color: var(--kig-section-header-bg);">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td class="text-center" width="30%">
                                {{rowData.date | date : 'medium'}}
                            </td>
                            <td class="text-center">
                                {{rowData.msg}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </tabset>
        </div>
    </div>
</ng-template>


<ng-template #deviceHWTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="std500px-modal">
    <!-- <div class="modal-content std500px-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Gateway Info From '{{device.name}}'</h5>
            <button
                (click)="hwModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
        <br>
        <div class=" modal-body">
            <div *ngIf="loadingHardwareInfo == false" class="form-group" style="line-height: 35px;">
                <table>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="name">Name:</label></td>
                        <td> <label id="name">{{gatewayInfo.name}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="ipaddress">IP Address:</label></td>
                        <td> <label id="ipaddress">{{gatewayInfo.ipAddress}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="netmask">Netmask:</label></td>
                        <td> <label id="netmask">{{gatewayInfo.netmask}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="netInterface">Net Interface:</label></td>
                        <td> <label id="netInterface">{{gatewayInfo.networkInterface}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="serial">Serial Number:</label></td>
                        <td> <label id="serial">{{gatewayInfo.serialNumber}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="macAddress">Mac Address:</label></td>
                        <td> <label id="macAddress">{{gatewayInfo.macAddress}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="mode">Acquistion Mode:</label></td>
                        <td> <label id="mode">{{gatewayInfo.mode}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="gpsLong">GPS Long:</label></td>
                        <td> <label id="gpsLong">{{gatewayInfo.gpsLocation.gpsLong}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="gpsLong">GPS Lat:</label></td>
                        <td> <label id="gpsLat">{{gatewayInfo.gpsLocation.gpsLat}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="gpsLong">GPS Alt:</label></td>
                        <td> <label id="gpsLat">{{gatewayInfo.gpsLocation.gpsAlt}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="version">Version:</label></td>
                        <td> <label id="version">{{gatewayInfo.version}}</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label style="margin-right: 15px; font-weight: 500;" for="version">ApiKey:</label></td>
                        <td> <label id="version">{{gatewayInfo.apiKey | slice:0:20 }}...</label></td>
                    </tr>
                    <tr>
                        <td align="right"><label for="useGWButton"> </label></td>
                        <td align="right">
                            <button type="button" class="btn btn-success" id="useGatewayData" name="useGatewayData" (click)="applyHardwareInfoFromGateway()" style="cursor: pointer; margin-top: 20px;">Use this info</button>
                        </td>
                    </tr> 
                </table>
            </div>

            <div *ngIf="loadingHardwareInfo" style="margin-bottom: 20px; text-align: center; color: rgb(136, 136, 136);">
                <i class="fa fa-spinner fa-spin" style="font-size: 32px"></i>
            </div>

        </div>
    </div>
</ng-template>
  
  
  <ng-template #preWaterScheduleDeleteTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="std500px-modal">
    <!-- <div class="modal-content std500px-modal"> -->
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Warning: Water schedule in use</h5>
        <button
            (click)="modalRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
        </button>
      </div>
      <br>
      <div class="text-center">
        <label>This water schedule can not be deleted while</label>
        <label>being used by one or more Event and Actions.</label>
      </div>
      <br>
    </div>
  </ng-template>


<ng-template #registrationConfirmTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="std500px-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">{{registrationConfirmHeader}}</h5>
            <button
                (click)="registrationConfirmModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
            </button>
        </div>

        <div style="padding: 20px; font-size: 14px;">
            <p style="margin-bottom: 20px;">{{registrationConfirmMessage}}</p>

            <label style="font-weight: 500; margin-bottom: 8px;">Token type</label>
            <div style="margin-left: 10px; margin-bottom: 6px;">
                <input type="radio" id="tokenTypeEs256" name="registrationTokenType" value="Es256" [(ngModel)]="registrationTokenType" [ngModelOptions]="{standalone: true}" />
                <label for="tokenTypeEs256" style="margin-left: 8px; font-weight: 400;">Compact token (recommended)</label>
            </div>
            <div style="margin-left: 10px; margin-bottom: 20px;">
                <input type="radio" id="tokenTypeRsa" name="registrationTokenType" value="Rsa" [(ngModel)]="registrationTokenType" [ngModelOptions]="{standalone: true}" />
                <label for="tokenTypeRsa" style="margin-left: 8px; font-weight: 400;">Standard token</label>
            </div>

            <div style="text-align: right;">
                <button type="button" class="btn btn-success" (click)="confirmRegistration()" style="margin-right: 10px;">Continue</button>
                <button type="button" class="btn btn-basic" (click)="registrationConfirmModalRef.hide()">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #bulkChangeTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="std500px-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Bulk Change</h5>
            <button
                (click)="bulkChangeModalRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
            </button>
        </div>

        <div style="padding: 20px; font-size: 14px;">
            <label style="font-weight: 500; margin-bottom: 20px;">Select Action</label><br>

            <input type="radio" style="cursor: pointer;" [(ngModel)]="bulkChangeAction" [ngModelOptions]="{standalone: true}" name="BulkChangeAction" value="Delete" />
            <label style="margin-left: 10px; margin-bottom: 12px;">Delete Selected</label><br>

            <div style="display: flex; align-items: center; margin-bottom: 12px;">
                <input type="radio" style="cursor: pointer;" [(ngModel)]="bulkChangeAction" [ngModelOptions]="{standalone: true}" name="BulkChangeAction" value="ChangeOwnership" />
                <label style="margin-left: 10px; margin-right: 10px; margin-bottom: 0;">Change Ownership To</label>
                <div style="width: 220px; height: 38px;">
                    <ngx-select-dropdown name="bulkOwnerGroup" [config]="userGroupconfig" [options]="userGroups" [(ngModel)]="bulkSelectedUserGroup" [ngModelOptions]="{standalone: true}"></ngx-select-dropdown>
                </div>
            </div>

            <input type="radio" style="cursor: pointer;" [(ngModel)]="bulkChangeAction" [ngModelOptions]="{standalone: true}" name="BulkChangeAction" value="Trust" />
            <label style="margin-left: 10px; margin-bottom: 20px;">Trust Selected</label><br>

            <input type="radio" style="cursor: pointer;" [(ngModel)]="bulkChangeAction" [ngModelOptions]="{standalone: true}" name="BulkChangeAction" value="Untrust" />
            <label style="margin-left: 10px; margin-bottom: 20px;">Untrust Selected</label><br>

            <div style="text-align: right;">
                <button type="button" class="btn btn-basic" (click)="bulkChangeModalRef.hide()">Cancel</button>
                <button type="button" class="btn btn-success" (click)="executeBulkChange()" [disabled]="bulkChangeAction == '' || (bulkChangeAction == 'ChangeOwnership' && !bulkSelectedUserGroup)" style="margin-right: 10px;">Execute</button>
                <div class="far fa-comment" aria-hidden="true" title="Add change-log notes" (click)="addNotes2ChangeLog()" style="display: inline-block; color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 5px; vertical-align: middle;"></div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #registrationResultsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="registrationResults-Modal">
    <!-- <div class="modal-content registrationResults-Modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Registration Results</h5>
            <button
                (click)="registrationResultsModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div style="padding: 30px;">
            <label style="margin-bottom: 20px; background-color: lightgray;">New Serial Number</label><br>
            <label>{{registrationResults.serialNumber}}</label>
            <hr>

            <label style="margin-top: 20px; background-color: lightgray;">Bearer Token (copy token). Token will not be accessible after closing this modal.</label><br><br>
            <label style="max-width: 650px; overflow-wrap: break-word;">{{registrationResults.jsonWebToken}}</label>
        </div>
    </div>
</ng-template>


<ng-template #IotDirectTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="iotDirect-Modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Direct Commands to '{{ device.name }}'</h5>
            <button
                (click)="iotDirectModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div class="modal-body" style="padding: 5px;">

            <textarea #textarea [scrollTop]="textarea.scrollHeight" [(ngModel)]="iotDirectHistory" style="width: 100%; min-height: 700px; background-color: rgb(35, 35, 35); color: white;" type="text" name="iotDirectHistory" ></textarea>

            <div style="display: flex">
                <input [(ngModel)]="iotDirectCommand" (keyup.enter)="iotDirectCommandEntered(iotDirectCommand)" [disabled]="iotDirectWaitingForConnection" placeholder="Command" style="width: 1295px; height: 35px; margin-bottom: 5px;" type="text" name="iotDirectCommand"/>
                <!-- <button type="button" class="btn btn-success" style="padding-top: 3px; height: 35px; margin-left: 10px;" (click)="clearIotDirectHistory()">Clear History</button> -->
                <button type="button" class="btn btn-success" style="padding-top: 3px; height: 35px; margin-left: 10px;" (click)="remoteContentViewEditLive(remoteContentEditTemplate, iotDirectCommand )">Edit File</button>
            </div>
            
            <div *ngIf="iotDirectWaitingForConnection" style="color: rgb(226, 226, 226); font-weight: bold; margin-bottom: 10px; align-items: center; display: flex; margin-top: -450px; margin-left: 500px;">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                <label style="margin-left: 40px;">Waiting for connection ...</label>
            </div>

        </div>
    </div>
</ng-template>


<ng-template #PopupSensorGroupListTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="sensorGroupPopup-Modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">All Sensor Groups</h5>
            <button
                (click)="sensorGroupsModalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div class="modal-body" style="padding: 5px;">

            <div *ngIf="loadingSensorGroups" style="text-align: center; color: rgb(136, 136, 136);">
                <i class="fa fa-spinner fa-spin" style="font-size: 32px"></i>
            </div>

            <div *ngIf="!loadingSensorGroups" style="max-height: 500px; overflow-y: auto;">
                <form  (ngSubmit)="searchSensorGroupTextChanged()">
                    <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchSensorGroupTextChanged()"></i>
                    <input [(ngModel)]="sensorGroupSearchText" placeholder="Search" style="height: 35px; width: 95%; margin-top: 5px;" type="text" name="sensorGroupSearchText" autocomplete="off" />
                </form>


                <table class="table">
                    <tr *ngFor="let sensorGroup of sensorGroupsDisplayed; let i = index">
                        <td>
                            <div (click)="addSensorGroupSensorsToGatewayList(sensorGroup)" style="margin-left: 20px; cursor: pointer; color: rgb(0, 123, 255);">
                                {{ sensorGroup.name }}
                            </div>
                        </td>
                        <td>
                            Sensor Count: {{ sensorGroup.sensors.length }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

</ng-template>